import { fromJS } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'

const initialState = fromJS({})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CREATE_GROUP:
      return state
        .set('creatingGroup', true)
        .delete('createGroupError')
        .delete('createdGroup')
    case actionTypes.CREATE_GROUP_DONE:
      return state.set('creatingGroup', false).set('createdGroup', action.group)
    case actionTypes.CREATE_GROUP_ERROR:
      return state
        .set('creatingGroup', false)
        .set('createGroupError', action.error)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
